import {
  ComputedStaticTextInput,
  type IComputedStaticTextInputProps,
} from '@framework/form/inputs/computed/ComputedStaticTextInput.tsx';
import { ConfigFormItem } from '../../../../../../../ui/form/ConfigFormItem.tsx';
import { type IPaymentRowWidget } from '../../IPaymentRowWidget.ts';

export interface IComputedNumberPaymentRowFieldProps {
  name: string;
  label: string;
  help?: string;
  readonly: boolean;
  format?: IComputedStaticTextInputProps['format'];
  widget: IPaymentRowWidget;
}

/**
 * Componente di renderizzazione di un campo di tipo numero calcolato
 * per la voce di costo
 */
export function ComputedNumberPaymentRowField(
  props: IComputedNumberPaymentRowFieldProps,
) {
  const { name, label, help, readonly, format, widget } = props;

  return (
    <ConfigFormItem
      name={name}
      label={label}
      help={help}
      readonly={readonly}
      widget={widget}
    >
      <ComputedStaticTextInput name={name} removeBorder format={format} />
    </ConfigFormItem>
  );
}
